import { CoreStatusExtended } from 'api-paths-cas';

export const allPathwayHandler = (stages: CoreStatusExtended[]) => {
  return stages.filter(stage => stage !== CoreStatusExtended.PATHWAY_REVIEW);
};
